import {
    GetDialingCodeWithAuth,
    GetDialingCodeWithoutAuth,
    ClearDialingCodeInstance
} from './DialingCodeConfig';
import { GetDialingCode } from './GetDialingCode';

export {
    GetDialingCode,
    GetDialingCodeWithAuth,
    GetDialingCodeWithoutAuth,
    ClearDialingCodeInstance
};

export default GetDialingCode;